import { slugify } from "utils/slugify";
import crypto from "crypto";

export function generateFormFieldName(label?: string) {
  return `${slugify(label ?? "field")}-${crypto
    .randomBytes(2)
    .toString("hex")}`.toLowerCase();
}
